var CookieConsent = function() {
	var self = this;

	$(".cookie-consent").on("click", ".dismiss", function(){
		$(".cookie-consent").hide();
		self.setCookie("cookie-consent", "consent", 3650);
	});

	this.getCookie = function (cname) {
	    var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for(var i = 0; i <ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}

	this.setCookie = function(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}


	if(this.getCookie("cookie-consent") != "consent") {
		setTimeout(function(){
			$(".cookie-consent").css("transform", "none");
		}, 1500);
	}
};

module.exports = CookieConsent;
